import {USERS_LOAD, USERS_UNLOAD} from "../constants/actionTypes";

const defaultUsersPage = { content: [], number: 0, size: 20, totalElements: 0 };

export default (state = { users: defaultUsersPage }, action) => {
    switch (action.type) {
        case USERS_LOAD: {
            const p = action.payload;
            let normalized;
            if (Array.isArray(p)) {
                normalized = { ...defaultUsersPage, content: p, totalElements: p.length, number: 0 };
            } else if (p && typeof p === 'object') {
                const content = Array.isArray(p.content) ? p.content : (Array.isArray(p.items) ? p.items : []);
                const totalElements = typeof p.totalElements === 'number' ? p.totalElements : (typeof p.total === 'number' ? p.total : content.length);
                const size = typeof p.size === 'number' ? p.size : (typeof p.pageSize === 'number' ? p.pageSize : defaultUsersPage.size);
                const number = typeof p.number === 'number' ? p.number : (typeof p.pageNumber === 'number' ? p.pageNumber : (typeof p.page === 'number' ? p.page : 0));
                normalized = { content, totalElements, size, number };
            } else {
                normalized = defaultUsersPage;
            }
            return {
                ...state,
                users: normalized,
            };
        }
        case USERS_UNLOAD:
            return {
                ...state,
                users: defaultUsersPage,
            }
        default:
            return state;
    }
}